// jQuery
window.$ = window.jQuery = require('jquery');
// global.$ = global.jQuery = require('jquery');

// Select2

// Temporary Axios Setup - This can be removed once integrated into the full app
if (!window.axios) {
   window.axios = require('axios');
   window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
   let token = document.head.querySelector('meta[name="csrf-token"]');

   if (token) {
       window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
   } else {
       console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
   }
}
